import React from 'react'
import './footer.css'
export default function Footer() {
    var stringCode = "</>"
    return (
        <footer>
            <p> {stringCode} by: <a href="https://mohamadhossein.ir/">MohamadHossein.ir</a> </p>
            <p><a rel="noreferrer" target="_blank" href="https://github.com/M-Hosseini80/calculator">github</a></p>
        </footer>
    )
}
